module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACMSURBVHgB7ZPRDYUgDEVbFnm+FQgD6OS6ADCCuggIf6aCXj9Nej9pew40gUij0bA88N6vOWcyxozW2p2AxBiHlNJc55xz/3PNdGbqwBJC+BEOH1r1i6DcfGLmDZEI+FZfLXsYHZTrQnq6gicACr8V9EBlfYzCHwUtSeETCocEDQmhcFggJK/+iEbzgRxpK57oFPTSwwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/renew_pc/img_chevron_down.png
// module id = bjfW
// module chunks = 1